<template>
  <div class="el-rate-wrap"
       :itemprop="hasReviews ? 'aggregateRating' : null"
       :itemscope="hasReviews"
       :itemtype="hasReviews ? 'http://schema.org/AggregateRating' : null">
    <el-rate
      v-model="rateValue"
      :colors="[]"
      disabled-void-color="#ccc"
      :disabled="disabled"
      @change="changeValue"
      :class="sizeClass" />
    <meta v-if="hasReviews" itemprop="ratingValue" :content="rateValue">
    <span v-if="hasReviews" class="el-rate__counter" itemprop="reviewCount">{{count}}</span>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [String, Number]
      },
      count: {
        type: [String, Number],
        default(){
          return 0
        }
      },
      disabled: {
        type: [String, Boolean]
      },
      size: {
        type: String
      }
    },

    data() {
      return {
        rateValue: this.value
      }
    },

    computed: {

      sizeClass() {
        switch (this.size) {
          case 'small':
            return 'el-rate--small';
            break;
          case 'medium':
            return 'el-rate--medium';
            break;

          case 'large':
            return 'el-rate--large';
            break;
        }
      },
      hasReviews() {
        return !!(this.count * 1);
      }
    },

    methods: {
      changeValue (value) {
        this.$emit('change', value);
      }
    },

    watch: {
      value(newVal) {
        this.rateValue = newVal;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .el-rate__counter {
    &::before{
      content: "("
    }
    &::after{
      content: ")"
    }
  }
</style>
